// src/pages/policy/sections/PrivacyPolicy.jsx
import { motion } from "framer-motion";
const item = {
  hidden: { opacity: 0, y: 6 },
  show: { opacity: 1, y: 0, transition: { duration: 0.16 } },
};

export default function PrivacyPolicy() {
  return (
    <section className="mb-12 space-y-4 text-gray-700 text-[15px] leading-relaxed">
      <motion.h2
        className="text-2xl font-bold text-gray-800 mb-2"
        variants={item}
        initial="hidden"
        animate="show"
      >
        Chính sách bảo mật thông tin cá nhân
      </motion.h2>

      <motion.p variants={item} initial="hidden" animate="show">
        Chúng tôi cam kết bảo vệ tuyệt đối thông tin cá nhân của người dùng theo
        các quy định của pháp luật hiện hành...
      </motion.p>

      <motion.ul
        className="list-disc list-inside ml-5 space-y-1"
        variants={item}
        initial="hidden"
        animate="show"
      >
        <li>Thông tin định danh: Họ tên, email, số điện thoại.</li>
        <li>
          Thông tin hành vi: thời lượng sử dụng, chức năng truy cập nhiều nhất.
        </li>
      </motion.ul>

      <motion.p variants={item} initial="hidden" animate="show">
        Người dùng có quyền yêu cầu xem, chỉnh sửa hoặc xóa dữ liệu cá nhân của
        mình...
      </motion.p>
    </section>
  );
}
